/** vuex store for services directory module  */
export const servicesDirectory = {
  namespaced: true,
  /** state (data) */
  state: () => ({
    selectedCustomAreas: [],
    satelliteView: false,
    servicesGroupsAndMetaHierarchy: null, //service groups and metadata hierarchy info
    selectedURLServiceIds: [], //service ids passed in URL params
    SDselectedServices: [], //Selected services in sidebar
    SDfetchedServices: {}, //Data for selected services
    SDcounts: {}, //Data counts for selected services
    SDmetadataIcons: {}, //Icons for selected service metadata
    SDbuiltPNGIcons: {},
    SDmapMarkers: [],
    fetchingServices: false,
    fetchingCustomAreas: false,
  }),
  /** setters */
  mutations: {
    setSelectedCustomAreas(state, value) {
      state.selectedCustomAreas = value;
    },
    setSatelliteView(state, value) {
      state.satelliteView = value;
    },
    setServicesGroupsAndMetaHierarchy(state, value) {
      state.servicesGroupsAndMetaHierarchy = value;
    },
    setSDselectedServices(state, value) {
      state.SDselectedServices = value;
    },
    setSDfetchedServices(state, value) {
      state.SDfetchedServices = value;
    },
    setSDcounts(state, value) {
      state.SDcounts = value;
    },
    setSDmetadataIcons(state, value) {
      state.SDmetadataIcons = value;
    },
    setSDbuiltPNGIcons(state, value) {
      state.SDbuiltPNGIcons = value;
    },
    setSDmapMarkers(state, value) {
      state.SDmapMarkers = value;
    },
    setFetchingServices(state, value) {
      state.fetchingServices = value;
    },
    setFetchingCustomAreas(state, value) {
      state.fetchingCustomAreas = value;
    },
    setSelectedURLServiceIds(state, value) {
      state.selectedURLServiceIds = value;
    },
  },
  /** getters */
  getters: {
    selectedCustomAreas: (state) => state.selectedCustomAreas,
    satelliteView: (state) => state.satelliteView,
    servicesGroupsAndMetaHierarchy: (state) =>
      state.servicesGroupsAndMetaHierarchy,
    SDselectedServices: (state) => state.SDselectedServices,
    SDfetchedServices: (state) => state.SDfetchedServices,
    SDcounts: (state) => state.SDcounts,
    SDmetadataIcons: (state) => state.SDmetadataIcons,
    SDbuiltPNGIcons: (state) => state.SDbuiltPNGIcons,
    SDmapMarkers: (state) => state.SDmapMarkers,
    fetchingServices: (state) => state.fetchingServices,
    fetchingCustomAreas: (state) => state.fetchingCustomAreas,
    selectedURLServiceIds: (state) => state.selectedURLServiceIds,
  },
  /** actions */
  actions: {
    addSelectedService(
      { state, commit, dispatch },
      { service, router, route },
    ) {
      if (!state.SDselectedServices.some((s) => s.id === service.id)) {
        const newServices = [...state.SDselectedServices, service];
        commit("setSDselectedServices", newServices);
        dispatch("updateUrlParams", { router, route });
      }
    },

    removeSelectedService(
      { state, commit, dispatch },
      { service, router, route },
    ) {
      const newServices = state.SDselectedServices.filter(
        (s) => s.id !== service.id,
      );
      commit("setSDselectedServices", newServices);
      dispatch("updateUrlParams", { router, route });
    },

    updateUrlParams({ state }, { router, route }) {
      const serviceIds = state.SDselectedServices.map((s) => s.id);

      const updatedQuery = {
        ...route.query,
      };

      if (serviceIds.length > 0) {
        updatedQuery.selectedServices = JSON.stringify(serviceIds);
      } else {
        delete updatedQuery.selectedServices;
      }

      router.replace({
        path: route.path,
        query: updatedQuery,
      });
    },

    initFromUrl({ commit }, route) {
      const selectedServiceIds = route.query.selectedServices;

      if (selectedServiceIds) {
        try {
          const serviceIds = JSON.parse(selectedServiceIds);
          commit(
            "setSelectedURLServiceIds",
            serviceIds.map((id) => ({ id })),
          );
        } catch (e) {
          console.error("Error parsing selectedServices from URL:", e);
        }
      }
    },
  },
};
